import React from "react";
import PropTypes from "prop-types";

import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { BackButton } from "components";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(4),
  },
  headerRow: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    marginTop: theme.spacing(1.5),
  },
  headerText: {
    minWidth: 0,
    flex: 1,
  },
  eyebrow: {
    textTransform: "uppercase",
    letterSpacing: "0.14em",
    fontSize: "0.72rem",
    fontWeight: 700,
    color: theme.palette.text.secondary,
  },
  title: {
    fontWeight: 700,
    letterSpacing: "-0.01em",
    lineHeight: 1.15,
    marginTop: theme.spacing(0.5),
  },
  subtitle: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.75),
    maxWidth: 720,
    lineHeight: 1.55,
  },
}));

const SettingsHeader = ({
  eyebrow,
  title,
  subtitle,
  action,
  backTo = "/myrestaurant",
  backLabel = "My Restaurant",
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <BackButton to={backTo} label={backLabel} />

      <Box className={classes.headerRow}>
        <Box className={classes.headerText}>
          {eyebrow && (
            <Typography className={classes.eyebrow}>{eyebrow}</Typography>
          )}
          {title && (
            <Typography variant="h4" className={classes.title}>
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="body2" className={classes.subtitle}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {action && <Box>{action}</Box>}
      </Box>
    </Box>
  );
};

SettingsHeader.propTypes = {
  eyebrow: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  action: PropTypes.node,
  backTo: PropTypes.string,
  backLabel: PropTypes.string,
};

export default SettingsHeader;
